<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { permsMethods } from '@state/helpers'
import { required, minLength } from 'vuelidate/lib/validators'
import PermissionsUpdateForm from '@views/management/perms/update-form'
import PermissionsCreateForm from '@views/management/perms/create-form'

export default {
  page: {
    title: 'Administration/Permissions',
    meta: [{ name: 'Permissions management', content: 'Administration/Permissions', }],
  },
  components: { Layout, PageHeader, BaseDatatable,
    PermissionsUpdateForm, PermissionsCreateForm },
  data() {
    return {
      title: 'Administration/Permissions',
      breadcrumbs: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Administration/Permissions',
          active: true,
        },
      ],
      sortBy: 'permission_type',
      sortDesc: false,
      tableHeaders: [
        {
          key: 'permission__name',
          label: this.$t('permissionsSection.name'),
          sortable: true
        },
        {
          key: 'permission__codename',
          label: this.$t('permissionsSection.codename'),
          sortable: true
        },
        {
          key: 'description',
          label: this.$t('permissionsSection.description'),
          sortable: true
        },
        {
          key: 'permission_type',
          label: this.$t('permissionsSection.type'),
          sortable: true
        },
        {
          key: 'actions',
          label: this.$t('basic.actions'),
        }
      ],
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      createForm: {
          name: '',
          codename: '',
          description: ''
      },
      updateForm: {
          url: '',
          name: '',
          codename: '',
          description: ''
      },
      action : '',
      toDelete: {},
      actionsLoadings: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false
    }
  },
  validations: {
    updateForm:{
      name: {
        required,
        minLength: minLength(4)
      },
      codename: {
        required
      },
    },
    createForm: {
      name: {
        required,
        minLength: minLength(4)
      },
      codename: {
        required
      },
    },
  },
  methods: {
    ...permsMethods,   

    myProvider(ctx) {
      const promise = this.fetchPerms(this.$table_params(ctx))
      return promise.then(data => {
        return data
      }).catch(error => {
        this.$axios_error_noty(error, this)
        return []
      })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = this.$t('permissionsSection.permission')+`: ${item.permission.name}`
      const promise = context.fetchPermsDetail(item.url)
      return promise.then(data => {
        context.detailModal.content = data
        context.detailModalShow = !context.detailModalShow
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      if (action === 'create'){
        this.createForm.name = ''
        this.createForm.codename = ''
        this.createForm.description = ''
        this.$v.createForm.$reset();
      }else {
        this.updateForm._id = ''
        this.updateForm.name = ''
        this.updateForm.codename = ''
        this.updateForm.description = ''
        this.$v.updateForm.$reset();
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create'){
        this.action = 'create'
        this.createUpdateModal.title = this.$t('basic.create')+' '+this.$t('permissionsSection.permission')
      }else if (action === 'update'){
        this.action = 'update'
        this.createUpdateModal.title = this.$t('basic.update')+' '+this.$t('permissionsSection.permission')
        this.updateForm._id = item._id
        this.updateForm.name = item.permission.name
        this.updateForm.codename = item.permission.codename
        this.updateForm.description = item.description
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    onFormSubmit(evt) {
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.updateForm.$anyError) {
        context.$v.updateForm.$touch()
      }
      let form = context.action === 'create' ? context.createForm : context.updateForm
      let completeForm = {
        '_id': form._id,
        'permission': form,
        'description': form.description,
        'permission_type' : 2
      }
      const promise = context.createUpdatePerms(completeForm)
      return promise.then(data => {
        if (completeForm._id){
          context.$generate_toast(context, 'success', context.$t('alerts.updated_successfully'))
        }else{
          context.$generate_toast(context, 'success', context.$t('alerts.created_successfully'))
        }
        context.createUpdateModalShow = !context.createUpdateModalShow
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },    
    deletePerm() {
      let context = this
      context.isSubmitting = true
      const promise = context.deletePerms(context.toDelete.url)
      return promise.then(data => {
        context.$generate_toast(context, 'success', context.$t('alerts.deleted_successfully'))
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
  }
}
</script>

<template> 
  <Layout>
    <PageHeader
      :title="title"
      :items="breadcrumbs"
    />

    <div class="row">
      <div class="col-md-12">
        <b-card >
            <b-button
              variant="primary"
              size="sm"
              @click="openCreateUpdateModal(null, null, 'create')"
              >
              <i class="fad fa-plus"></i> {{ $t('basic.add') }}
          </b-button>
          <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              :sortby="sortBy"
              :sortdesc="sortDesc"
              >
              <template v-slot:cell(permission__name)="data">
                {{data.item.name}}
              </template>
              <template v-slot:cell(permission__codename)="data">
                {{data.item.codename}}
              </template>
              <template v-slot:cell(permission_type)="data">
                {{data.item.permission_type}}
              </template>
              <template v-slot:cell(actions)="row">
                  <b-button-group size="xs">
                    <b-button
                      :id="`info-btn-${row.index}`"
                      variant="transparent-1"
                      class="text-info p-1"
                      :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                      @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                      >
                      <i v-if="!actionsLoadings[`info-btn-${row.index}`]" class="fad fa-circle-info fe-2x"></i>
                      <b-spinner
                        v-if="actionsLoadings[`info-btn-${row.index}`]"
                        small
                        label="Spinning"
                        variant="info"
                        >
                      </b-spinner>
                    </b-button>
                    <b-tooltip
                      :target="`info-btn-${row.index}`"
                      triggers="hover"
                      placement="left"
                      variant="info">
                      {{ $t('basic.info') }}
                    </b-tooltip>
                    <b-button
                      v-if="row.item.permission_type === 2"
                      :id="`update-btn-${row.index}`"
                      :disabled="isSubmitting"
                      variant="transparent-1"
                      class="text-warning p-1"
                      @click="openCreateUpdateModal(row.item, row.index, 'update')"
                      >
                      <i class="fad fa-pen fe-2x"></i>
                    </b-button>
                    <b-tooltip
                      v-if="row.item.permission_type === 2"
                      :target="`update-btn-${row.index}`"
                      triggers="hover"
                      placement="left"
                      variant="warning">
                      {{ $t('basic.edit') }}
                    </b-tooltip>

                    <b-button
                      v-if="row.item.permission_type === 2"
                      :id="`delete-btn-${row.index}`"
                      :disabled="isSubmitting"
                      variant="transparent-1"
                      class="text-danger p-1"
                      @click="openDeleteModal(row.item, row.index)"
                      >
                      <i class="fad fa-trash-xmark"></i>
                    </b-button>
                    <b-tooltip
                      v-if="row.item.permission_type === 2"
                      :target="`delete-btn-${row.index}`"
                      triggers="hover"
                      placement="left"
                      variant="danger">
                      {{ $t('basic.delete') }}
                    </b-tooltip>
                    
                  </b-button-group>
              </template>
          </BaseDatatable>
        </b-card>

        <!-- Detail modal -->
        <b-modal 
          :id="detailModal.id"
          v-model="detailModalShow"
          :title="detailModal.title"
          ok-only 
          @hide="resetdetailModal">
          <!-- <pre>{{ detailModal.content }}</pre> -->
          <table class="table-hover table-sm mb-0">
            <tr><th style="text-align:right">{{ $t('permissionsSection.name') }}</th><td>{{_.capitalize(detailModal.content.permission ? detailModal.content.permission.name : "")}}</td></tr>
            <tr><th style="text-align:right">{{ $t('permissionsSection.description') }}</th><td>{{_.capitalize(detailModal.content.description)}}</td></tr>
            <tr><th style="text-align:right">{{ $t('permissionsSection.type') }}</th><td>{{_.capitalize(detailModal.content.permission_type_verbose)}}</td></tr>
            <tr>
              <th style="text-align:right">{{ $t('permissionsSection.members') }}</th>
              <td v-if="detailModal.content.permission && 'user_set_info' in detailModal.content.permission && detailModal.content.permission.user_set_info.length">
                <ul>
                  <li v-for="(user, index) in detailModal.content.permission.user_set_info" :key="index">
                    {{ user.first_name ? `${user.first_name} ${user.last_name } (${user.username})` : user.username }}
                  </li>
                </ul>
              </td>
              <td v-else class="text-muted">{{ $t('basic.empty_list')}} </td>
            </tr>
            <tr>
              <th style="text-align:right">{{ $t('permissionsSection.groups') }}</th>
              <td v-if="detailModal.content.permission && 'group_set_info' in detailModal.content.permission && detailModal.content.permission.group_set_info.length">
                <ul>
                  <li v-for="(group, index) in detailModal.content.permission.group_set_info" :key="index">
                    {{ _.capitalize(group.name) }}
                  </li>
                </ul>
              </td>
              <td v-else class="text-muted">{{ $t('basic.empty_list')}} </td>
            </tr>
          </table>
        </b-modal>
        <!-- Create-Update modal -->
        <b-modal 
          :id="createUpdateModal.id"
          v-model="createUpdateModalShow"
          :title="createUpdateModal.title"
          :size="action === 'create' ? 'sm' : 'lg'"
          >
            <PermissionsUpdateForm 
              v-if="action === 'update'" 
              :validator="$v.updateForm"
              :onformsubmit="onFormSubmit"
              :form="updateForm">
            </PermissionsUpdateForm>
            <PermissionsCreateForm 
              v-if="action === 'create'" 
              :validator="$v.createForm"
              :onformsubmit="onFormSubmit"
              :form="createForm">
            </PermissionsCreateForm>
          <template v-slot:modal-footer>
              <b-button
                variant="secondary"
                size="sm"
                class="float-right"
                @click="createUpdateModalShow = !createUpdateModalShow"
              >
              {{ $t('basic.cancel') }}
            </b-button>
            <b-button
              type="submit"
              form="form"
              size="sm"
              variant="primary"
              :disabled="action === 'create' ? $v.createForm.$invalid || isSubmitting : $v.updateForm.$invalid || isSubmitting"
            >
              <span
                v-if="!isSubmitting"
                >
                {{ $t('submit') }}
              </span>
              <b-spinner
                v-if="isSubmitting"
                small
                label="Spinning"
                variant="light"
                >
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
        <!-- Delete modal -->
        <b-modal
          id="delete-modal"
          v-model="deleteModalShow"
          :title="$t('basic.delete')+' '+$t('permissionsSection.permission')"
          :ok-title="$t('basic.delete')"
          ok-variant="danger"
          @hidden="resetDeleteModal"
          @ok="deletePerm"
          >
          <p>
            {{ $t('permissionsSection.are_you_sure') }} <b>{{ toDelete ? toDelete.permission ? toDelete.permission.name : '' : '' }}</b> ?
          </p>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel">
              {{ $t('basic.cancel') }}
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              :disabled="isSubmitting"
              @click="ok">
              <span
                v-if="!isSubmitting"
                >
                {{ $t('delete') }}
              </span>
              <b-spinner
                v-if="isSubmitting"
                small
                label="Spinning"
                variant="light"
                >
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
